let PackagesItem = [
    {
        id: 1,
        trackTitle: "Pro day 🔥",
        trackSubtitle: "For Senior Python Developers",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to Q&A sessions',
        trackLink: 'https://geekle.us/ticket/1662732403767x952094390236741600',
    },
    {
        id: 2,
        trackTitle: "Junior Day",
        trackSubtitle: "For Junior&Middle Python Developers",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Entry-level track',
        trackLink: 'https://geekle.us/ticketfree/1645541578245x518639353882214400',
    },
];

export default PackagesItem;
